import React, { Fragment } from 'react';
import AbstractComponent from '../../../AbstractComponent';
import Input from '../../../layout/input/Input';
import InputSelect from '../../../layout/input/InputSelect';
import InputTextArea from '../../../layout/input/InputTextArea';
import Panel from '../../../layout/panel/Panel';


class Loja extends React.Component{
    constructor(props){
        super(props);
    }

    onChange(e, i) {        
        let lista = this.props.loja;
        let opcao = lista[i];
    
        opcao[e.target.name] = e.target.value
    
        lista.splice(i, 1, opcao);
             
        this.props.onChangeForPropsLojas(lista);        
    }  


    render(){
        return(
            <section id="loja">

                {this.props.loja.map((item, i) => (
                    <Panel 
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        title={`Informações da(o) ${item.nome_loja}`}
                        key={i}
                    >
                        <Input
                            md={6} 
                            xs={6} 
                            sm={6} 
                            lg={6}
                            id="nome_loja"
                            nome="nome_loja"
                            tooltip="Insira o nome(Matriz/ Filial) da loja."                        
                            value={item.nome_loja}                                         
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Nome da Loja
                        </Input>

                        <Input
                            md={6} 
                            xs={6} 
                            sm={6} 
                            lg={6}
                            id="telefone"
                            nome="telefone"
                            tooltip="Insira o Telefone da loja"                        
                            value={item.telefone}                                            
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Telefone:
                        </Input> 

                        <InputTextArea
                            md={12} 
                            xs={12} 
                            sm={12} 
                            lg={12}
                            rows = {1}
                            id="endereco_completo"
                            nome="endereco_completo"                        
                            tooltip="Informe o Endereço Completo da loja"                            
                            value={item.endereco_completo} 
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Endereço Completo:
                        </InputTextArea> 
                        <InputTextArea
                            md={12} 
                            xs={12} 
                            sm={12} 
                            lg={12}
                            rows = {5}
                            id="iframe"
                            nome="iframe"                                                                               
                            tooltip="Informe o Iframe do google maps, referente ao endereço da loja" 
                            value={item.iframe}             
                            onChange={(e) => this.onChange(e, i)}
                        >
                            Iframe: 
                        </InputTextArea> 
                    </Panel>  
                ))}     
            </section>

        )
    }
}

export default Loja;
